<template>
    <div id="reveal-effect-container">
        <canvas id="reveal-effect" style="height: 1200px"></canvas>
    </div>
</template>

<script>
import * as THREE from 'three'
import TweenMax from "gsap/TweenMax"
console.log(THREE, THREE.WebGLRenderer)

export default {
    name: 'Reveal-effect',
    mounted() {
        this.TMath = THREE.Math
        this.init()
    },
    data() {
        return {
            canvasEl: null,
            renderer: null,
            camera: null,
            scene: null,
            geometry: null,
            cameraCtrl: null,
            width: null,
            height: null,
            cx: null,
            cy: null,
            wWidth: null,
            wHeight: null,
            TMath: null,
            conf: {
                color: 0xffffff,
                objectWidth: 12,
                objectThickness: 3,
                ambientColor: 0x808080,
                light1Color: 0xffffff,
                shadow: false,
                perspective: 75,
                cameraZ: 75,
            },
            objects: [],
            geometry: null,
            material: null,
            hMap: null,
            hMap0: null,
            nx: null,
            ny: null,


        }
    },
    methods: {
        init() {
            this.canvasEl = document.getElementById('reveal-effect')
            this.renderer = new THREE.WebGLRenderer({
                canvas: this.canvasEl,
                antialias: true,
                alpha: true
            });
            console.log(window.innerHeight)
            this.renderer.setSize(window.innerWidth, 1000);
            document.body.appendChild(this.renderer.domElement);

            this.camera = new THREE.PerspectiveCamera(this.conf.perspective, window.innerWidth / window.innerHeight, 0.1, 1000);
            this.camera.position.z = this.conf.cameraZ;

            this.scene = new THREE.Scene();
            this.geometry = new THREE.BoxGeometry(this.conf.objectWidth, this.conf.objectWidth, this.conf.objectThickness);

            // window.addEventListener('load', this.initScene);
            document.body.addEventListener('click', this.initScene);

            setTimeout(() => {

                this.initScene()
            }, 10);

            this.animate();
        },
        initScene() {
            this.onResize();
            this.scene = new THREE.Scene();
            this.initLights();
            this.initObjects();
        },

        initObjects() {
            this.objects = [];
            this.nx = Math.round(this.wWidth / this.conf.objectWidth) + 1;
            this.ny = Math.round(this.wHeight / this.conf.objectWidth) + 1;
            let mesh, x, y;
            for (let i = 0; i < this.nx; i++) {
                for (let j = 0; j < this.ny; j++) {
                    this.material = new THREE.MeshLambertMaterial({ color: this.conf.color, transparent: true, opacity: 1 });
                    mesh = new THREE.Mesh(this.geometry, this.material);
                    x = -this.wWidth / 2 + i * this.conf.objectWidth;
                    y = -this.wHeight / 2 + j * this.conf.objectWidth;
                    mesh.position.set(x, y, 0);
                    this.objects.push(mesh);
                    this.scene.add(mesh);
                }
            }
            // document.body.classList.add('loaded');
            this.startAnim();
        },

        startAnim() {
            document.body.classList.remove('revealed');
            this.objects.forEach(mesh => {
                mesh.rotation.set(0, 0, 0);
                mesh.material.opacity = 1;
                mesh.position.z = 0;
                let delay = this.TMath.randFloat(.1, .5);
                let rx = this.TMath.randFloatSpread(2 * Math.PI);
                let ry = this.TMath.randFloatSpread(2 * Math.PI);
                let rz = this.TMath.randFloatSpread(2 * Math.PI);
                TweenMax.to(mesh.rotation, 2, { x: rx, y: ry, z: rz, delay: delay });
                TweenMax.to(mesh.position, 2, { z: 80, delay: delay + 0.5, ease: Power1.easeOut });
                TweenMax.to(mesh.material, 2, { opacity: 0, delay: delay + 0.5 });
            });
            setTimeout(() => {
                document.body.classList.add('revealed');
                // debugger
                this.canvasEl.remove()
            }, 2500);
        },

        animate() {
            requestAnimationFrame(this.animate);
            this.renderer.render(this.scene, this.camera);
        },

        onResize() {
            this.width = window.innerWidth; this.cx = this.width / 2;
            this.height = 1000; this.cy = this.height / 2;
            this.camera.aspect = this.width / this.height;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(this.width, this.height);

            this.size = this.getRendererSize();
            this.wWidth = this.size[0];
            this.wHeight = this.size[1];
        },

        getRendererSize() {
            const cam = new THREE.PerspectiveCamera(this.conf.perspective, this.camera.aspect);
            const vFOV = cam.fov * Math.PI / 180;
            const height = 2 * Math.tan(vFOV / 2) * Math.abs(this.conf.cameraZ);
            const width = height * cam.aspect;
            return [width, height];
        },

        initLights() {
            this.scene.add(new THREE.AmbientLight(this.conf.ambientColor));
            let light = new THREE.PointLight(0xffffff);
            light.position.z = 100;
            this.scene.add(light);
        },
    }
}
</script>